<!-- <app-dynamic-form [inputRowsObservable]="dynamicInputRows"></app-dynamic-form> -->


<div class="row">
    <div class="clearfix"></div> 
    <div class="col-lg-3 float-left">
        <div class="sidebar-listing"> 
           
            <div class="top_heading"> 
                <div class="col-md-10">Placeholders</div>
            </div> 
            
            <ul class="mt-2 mb-2">
 
                <li *ngFor="let _placeHoldersMenu of placeHolderArray">
                    <div class="placeHolderDropDown" (click)="_placeHoldersMenu.show = !_placeHoldersMenu.show">
                        <div><i class="fas fa-chevron-down"></i> {{_placeHoldersMenu.name}}</div>                       
                    </div>
                    <div class="" [ngClass]="{'d-none' : _placeHoldersMenu.show == false}">
                        <div class="placeHolderDropDown-child" *ngFor="let group of _placeHoldersMenu.groups; let i = index">
                            <div class="placeHolderDropDown-child-grp">
                                <div class="placeHolderDropDown-child-item" (click)="group.show = !group.show" >
                                  <!-- <div  ngxClipboard (cbOnSuccess)="copied($event, group)"
                                  [cbContent]="group.id != null ? '<%'+group.name+':'+group.id+'%>' : '<%'+group.name+'%>'"> {{group.name}}</div> -->
                                  <div> {{group.name}}</div>
                                </div>
                                <div class="placeHolderDropDown-child-subGrp" *ngFor="let place of group.placeholders" [ngClass]="{'d-none' : group.show == false}">
                                    <div  ngxClipboard (cbOnSuccess)="copied($event, place)"
                                    [cbContent]="place.id != null ? '<%'+place.displayName+':'+place.id+'%>' : '<%'+place.fieldName+'%>'">  {{place.displayName}}</div>
                                </div>
                            </div>
                            <!-- {{group.placeholders | json}} -->
                        </div>
    
                        <div class="placeHolderDropDown-child" *ngFor="let holder of _placeHoldersMenu.placeholders">
                            <div class="placeHolderDropDown-child-placeholder">
                                <div  ngxClipboard (cbOnSuccess)="copied($event, holder)"
                                [cbContent]="holder.id != null ? '<%'+holder.displayName+':'+holder.id+'%>' : '<%'+holder.fieldName+'%>'"> {{holder.displayName}}</div>
                            </div> 
                        </div>
                    </div>
                    
                </li>
            </ul>
        </div>
    </div>


    <div class="col-md-9 float-right"> 
        <div class="rightside-panel"  id="dataPanel"> 

            <ul class="nav nav-tabs nav-justified pdfTabsNav">
                <li class="active" *ngFor="let tabs of pdfTabs; let i = index" (click)="formTabClick(tabs.noOfPages, tabs.displayName, tabs.htmlLocation, tabs.id)"><a class="nav-link" [ngClass]="{'activepdfTabsNav': formName === tabs.displayName}">{{tabs.displayName}}</a></li>
            </ul>
            <div class="dropdown">
                <span style="margin:0px 10px 0px 10px">Select Pages to be Mapped</span>
                <button class="btn btn-primary custom-button-pages dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{formName}}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="height:400px; overflow: auto">
                    <div style="border-bottom: 1px solid #cecece; width: 100%;; display:block; overflow: hidden;">
                        <input style="width:20px; float: left; margin-left:10px;" type="checkbox" (change)="selectAll(selectAllInput)" [(ngModel)]="selectAllInput">
                        <span style="margin-top: 6px;float: left; padding-left: 10px; color: #000;">Select All</span>
                      </div>
                  <div style="border-bottom: 1px solid #cecece; width: 100%;; display:block; overflow: hidden;" *ngFor="let item of pagesCount; let i = index;">
                    <input style="width:20px; float: left; margin-left:10px;" [(ngModel)]="item.isSelected" name="checkboxInput" class="checkboxInput" type="checkbox" (change)="getPageNnmber($event, i)"> 
                    <span style="margin-top: 6px;float: left; padding-left: 10px; color: #000;"> Page {{ i+1 }}</span> 
                  </div>
                </div>
              </div>
            <iframe *ngIf="formName != '' " [src]="pdfURL" noborder="0" width="100%" height="800" scrolling="yes" seamless></iframe>
        </div>

        <div class="clearfix"></div>
        <p-divider type="dashed"></p-divider>
        <div class="row" style="  justify-content: end;">
            <div class="buttonContainer float-right">
                <div> <button type="button" class="btn vdCancelBtn mr-3">CANCEL</button></div>
                <div> <button type="submit" class="btn vdCreateBtn mr-3">NEXT</button></div>
            </div>
        </div>
    </div>
</div>


